import { useQuery } from '@tanstack/react-query';
import { Form, type FormInstance } from 'antd';
import type { FormServicoValues } from '@/features/servico/types/Servico';
import { TableDefault } from '@/components/antd/TableDefault';
import { apiProdutoAlteracaoPrecoGet } from '@/features/produto/api/apiProdutoAlteracaoPrecoGet';
import { ProdutoTipoAlteracao } from '@/features/produto/types/ProdutoAlteracaoPreco';
import { usePagination } from '@/std/pagination/usePagination';
import { ServicoTabKeyHistoricoAlteracao } from '../useServicoTabItems';
import { servicoTabHistoricoAlteracaoColumns } from './servicoTabHistoricoAlteracaoColumns';

export function ServicoTabHistoricoAlteracaoCustoMedio({
    form,
    tab2,
}: {
    form: FormInstance<FormServicoValues>;
    tab2: ServicoTabKeyHistoricoAlteracao;
}) {
    const { params, onTableChange } = usePagination();

    const tipo = ProdutoTipoAlteracao.PrecoMedio.toString();

    const pro_idpk = Form.useWatch('pro_idpk', form);

    const { data, isFetching } = useQuery({
        enabled: !!pro_idpk && tab2 === ServicoTabKeyHistoricoAlteracao.CustoMedio,
        queryFn: () =>
            apiProdutoAlteracaoPrecoGet({
                ...params,
                orderby: 'alp_data_insercao desc',
                qtde_registros: 100,
                tipo,
                where: `alp_produto_idpk = ${pro_idpk}`,
            }),
        queryKey: ['apiProdutoAlteracaoPrecoGet', tipo, params, pro_idpk],
    });

    return (
        <div className='flex flex-col gap-2 p-5'>
            <TableDefault
                columns={servicoTabHistoricoAlteracaoColumns}
                dataSource={data?.registros}
                loading={isFetching}
                onChange={onTableChange}
                pagination={false}
                rowKey='alp_idpk'
            />
        </div>
    );
}
